import { apiSlice } from '../../apiSlice';
import { setCredentials } from './authSlice';

export const dealsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsersByPartner: builder.mutation({
      query: (body) => ({
        url: `/api/users/getallusersbypartner`,
        method: 'POST',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    deleteUser: builder.mutation({
      query: (body) => ({
        url: `/api/users/deleteuser`,
        method: 'DELETE',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    updateUserRole: builder.mutation({
      query: (body) => ({
        url: `/api/users/edituserrole`,
        method: 'PUT',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    updateUserPasswordAdminPanel: builder.mutation({
      query: (body) => ({
        url: `/api/users/edituserpasswordadminpanel`,
        method: 'PUT',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getUsersWazuh: builder.mutation({
      query: () => ({
        url: '/api/users/wazuhusers',
        method: 'GET',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getRecentUsersByCountry: builder.mutation({
      query: () => ({
        url: `/api/users/getrecentusersbycountry`,
        method: 'GET',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    updateAccountPassword: builder.mutation({
      query: (body) => ({
        url: `/api/users/editaccountpassword/${body.uuid}`,
        method: 'PUT',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.accesstoken) {
            dispatch(setCredentials({ accesstoken: data.accesstoken }));
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    forceChangePassword: builder.mutation({
      query: (body) => ({
        url: `/api/users/forcechangepassword`,
        method: 'PUT',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.accesstoken) {
            dispatch(setCredentials({ accesstoken: data.accesstoken }));
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    sendUserPassword: builder.mutation({
      query: (body) => ({
        url: `/api/users/senduserpassword`,
        method: 'POST',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getAllUsers: builder.mutation({
      query: () => ({
        url: `/api/users/getallusers`,
        method: 'GET',
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    changeUserPartner: builder.mutation({
      query: (body) => ({
        url: `/api/users/changeuserpartner`,
        method: 'PUT',
        body: body,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
  }),
});

export const {
  useGetAllUsersByPartnerMutation,
  useDeleteUserMutation,
  useUpdateUserRoleMutation,
  useUpdateUserPasswordAdminPanelMutation,
  useGetUsersWazuhMutation,
  useGetRecentUsersByCountryMutation,
  useUpdateAccountPasswordMutation,
  useForceChangePasswordMutation,
  useSendUserPasswordMutation,
  useGetAllUsersMutation,
  useChangeUserPartnerMutation,
} = dealsApiSlice;
